import { Modal } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { Formik } from "formik";
import FormField from "../../common/FormField/FormField";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import useViewer from "../../../hooks/useViewer";
const ChatModal = ({
  modal,
  setModal,
  askQuestionButtonColor,
  askQuestionTextColor,
}) => {

  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const { userObject } = useViewer();

  async function onFormSubmit(values) {
    let stayOnModal = false;
    try {
      if(!Boolean(values?.messageText)){
        enqueueSnackbar("Text question is empty", {
          variant: "error",
        });
        stayOnModal = !stayOnModal;
        return;
      }
      setLoader({ state: true, message: "Ask questions..." });
      const payload = {
        eventId: String(userObject?.eventId),
        fromViewerId: String(userObject?.id),
        messageText: values?.messageText,
        audioVideoMessageUrl: "0",
        readStatus: "0",
        answeredStatus: "0",
        name: userObject?.fullName
          ? String(userObject?.fullName)
          : userObject?.firstName
            ? String(userObject?.firstName)
            : String(userObject?.lastName),
        role: "eventviewer",
      };
      const response = await EventService.saveEventQuestions(payload);
      if (response) {
        enqueueSnackbar("Question sent successfully", {
          variant: "success",
        });
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      if(!stayOnModal){
          setLoader({ state: false });
          setModal({ state: false });
        }
    }
  }

  return (
    <Modal open={modal?.state} onClose={() => setModal({ state: false })}>
      <DrawerContainer>
        <Container>
          <HeadingContainer>
            <CloseModal
              onClick={() => setModal({ state: false })}>
              X
            </CloseModal>
          </HeadingContainer>
         
            <Formik
              initialValues={{
                messageText: "",
              }}
              enableReinitialize
              validateOnBlur
              validationSchema={""}
              validateOnChange
              onSubmit={onFormSubmit}
            >
              {({
                values,
                handleChange,
                errors,
                handleSubmit,
                touched,
                setFieldValue,
                setFieldError,
                handleBlur,
            }) => (
              
                <form>
                <div style={{ margin: 40, marginTop: 15,  marginBottom: 10 }}>
                  
                    <div style={{ width: "100%" }}>
                      <FormField
                        input={{
                          name: "messageText",
                         
                          type: "textarea",
                          placeholder: "Type your question here",
                        }}
                        labelStyle={{ fontSize: 16, color: "#000000" }}
                        style={{ backgroundColor: "#f9f9f9", fontSize: "16px" }}
                        multiline
                        maxLength={0}
                        {...{
                          touched,
                          errors,
                          values,
                          handleChange,
                          handleBlur,
                        }}
                      />
                    </div>
                    <div style={{
                      display: "flex", justifyContent: "center",
                    }}>
                      <PrimaryCTAButton
                        style={{
                          width: "70px",
                          height: "30px",
                          padding: "5px 5px",
                          marginBottom: "20px",
                          backgroundColor: askQuestionButtonColor,
                          color: askQuestionTextColor,
                          borderRadius: "8px",
                          fontSize: "15px",
                          fontWeight: 500,
                          textTransform: "none",
                          border: "none",
                        }}
                        onClick={handleSubmit}
                      >
                        Send
                      </PrimaryCTAButton>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          
        </Container>
      </DrawerContainer>
    </Modal>
  );
};

export default ChatModal;

const Container = styled.div`
  margin: 0 15px;
  background-color: rgb(249, 249, 249, 0.8);
  outline: none;
  //border-radius: 8px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;

const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${theme?.breakpoints?.sm_up} {
    max-width: 60%;
  }
`;

const HeadingContainer = styled.div`
  //padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

// const FormContainer = styled.p`
//  // padding-top: 14px;
//   //padding-left: 54px;
//   //padding-bottom: 26px;
//   & form {
//     padding-top: 10px;
//   }
// `;

const CloseModal = styled.div`
  // width: 14px;
  // height: 14px;
  // object-fit: contain;
  // cursor: pointer;
  // position: absolute;
  // right: 10px;
  
      position: absolute;
    width: 30px;
    height: 23px;
    right: 0px;
    top: 0;
    background-color: red;
    color: white;
    display: flex;
    justify-content: center;
  cursor:pointer;
`;